"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSmartDate = exports.SmartDates = exports.today = exports.DatePickerTypeOptions = exports.SmartDateTypeOptions = void 0;
var date_fns_1 = require("date-fns");
exports.SmartDateTypeOptions = {
    currentMonthMTD: 'Current Month (MTD)',
    lastMonth: 'Last Month',
    currentQuarterQTD: 'Current Quarter (QTD)',
    currentYearYTD: 'Current Calendar Year (CYTD)',
    yearToLastMonth: 'Year to Last Month',
    last2Months: 'Last 2 Months',
    last3Months: 'Last 3 Months',
    last12Months: 'Last 12 Months',
    lastQuarter: 'Last Quarter',
    last2Quarters: 'Last 2 Quarters',
    last3Quarters: 'Last 3 Quarters',
    last4Quarters: 'Last 4 Quarters',
    lastCalendarYear: 'Last Calendar Year',
    last2Years: 'Last 2 Years',
    last3Years: 'Last 3 Years',
    last5Years: 'Last 5 Years',
    inceptionToLastMonth: 'Inception to Last Month',
    sinceInception: 'Since Inception',
};
exports.DatePickerTypeOptions = {
    dateRange: 'dateRange',
    firstAndLastOfMonth: 'firstAndLastOfMonth',
};
exports.today = date_fns_1.startOfToday();
var lastQuarter = {
    name: exports.SmartDateTypeOptions.lastQuarter,
    startDate: date_fns_1.startOfQuarter(date_fns_1.subQuarters(exports.today, 1)),
    endDate: date_fns_1.endOfQuarter(date_fns_1.subQuarters(exports.today, 1)),
};
var last2Quarters = {
    name: exports.SmartDateTypeOptions.last2Quarters,
    startDate: date_fns_1.startOfQuarter(date_fns_1.subQuarters(exports.today, 2)),
    endDate: date_fns_1.endOfQuarter(date_fns_1.subQuarters(exports.today, 1)),
};
var last3Quarters = {
    name: exports.SmartDateTypeOptions.last3Quarters,
    startDate: date_fns_1.startOfQuarter(date_fns_1.subQuarters(exports.today, 3)),
    endDate: date_fns_1.endOfQuarter(date_fns_1.subQuarters(exports.today, 1)),
};
var last4Quarters = {
    name: exports.SmartDateTypeOptions.last4Quarters,
    startDate: date_fns_1.startOfQuarter(date_fns_1.subQuarters(exports.today, 4)),
    endDate: date_fns_1.endOfQuarter(date_fns_1.subQuarters(exports.today, 1)),
};
var lastMonth = {
    name: exports.SmartDateTypeOptions.lastMonth,
    startDate: date_fns_1.startOfMonth(date_fns_1.subMonths(exports.today, 1)),
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var yearToLastMonth = {
    name: exports.SmartDateTypeOptions.yearToLastMonth,
    startDate: date_fns_1.startOfYear(exports.today),
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var last2Months = {
    name: exports.SmartDateTypeOptions.last2Months,
    startDate: date_fns_1.startOfMonth(date_fns_1.subMonths(exports.today, 2)),
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var last3Months = {
    name: exports.SmartDateTypeOptions.last3Months,
    startDate: date_fns_1.startOfMonth(date_fns_1.subMonths(exports.today, 3)),
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var last12Months = {
    name: exports.SmartDateTypeOptions.last12Months,
    startDate: date_fns_1.startOfMonth(date_fns_1.subMonths(exports.today, 12)),
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var lastCalendarYear = {
    name: exports.SmartDateTypeOptions.lastCalendarYear,
    startDate: date_fns_1.startOfYear(date_fns_1.subYears(exports.today, 1)),
    endDate: date_fns_1.endOfYear(date_fns_1.subYears(exports.today, 1)),
};
var last2Years = {
    name: exports.SmartDateTypeOptions.last2Years,
    startDate: date_fns_1.startOfYear(date_fns_1.subYears(exports.today, 2)),
    endDate: date_fns_1.endOfYear(date_fns_1.subYears(exports.today, 1)),
};
var last3Years = {
    name: exports.SmartDateTypeOptions.last3Years,
    startDate: date_fns_1.startOfYear(date_fns_1.subYears(exports.today, 3)),
    endDate: date_fns_1.endOfYear(date_fns_1.subYears(exports.today, 1)),
};
var last5Years = {
    name: exports.SmartDateTypeOptions.last5Years,
    startDate: date_fns_1.startOfYear(date_fns_1.subYears(exports.today, 5)),
    endDate: date_fns_1.endOfYear(date_fns_1.subYears(exports.today, 1)),
};
var inceptionToLastMonth = {
    name: exports.SmartDateTypeOptions.inceptionToLastMonth,
    endDate: date_fns_1.endOfMonth(date_fns_1.subMonths(exports.today, 1)),
};
var dateRangeSmartDates = new Map([
    [exports.SmartDateTypeOptions.lastQuarter, lastQuarter],
    [exports.SmartDateTypeOptions.last2Quarters, last2Quarters],
    [exports.SmartDateTypeOptions.last3Quarters, last3Quarters],
    [exports.SmartDateTypeOptions.last4Quarters, last4Quarters],
    [
        exports.SmartDateTypeOptions.currentQuarterQTD,
        {
            name: exports.SmartDateTypeOptions.currentQuarterQTD,
            startDate: date_fns_1.startOfQuarter(exports.today),
            endDate: exports.today,
        },
    ],
    [exports.SmartDateTypeOptions.lastMonth, lastMonth],
    [exports.SmartDateTypeOptions.yearToLastMonth, yearToLastMonth],
    [
        exports.SmartDateTypeOptions.currentMonthMTD,
        {
            name: exports.SmartDateTypeOptions.currentMonthMTD,
            startDate: date_fns_1.startOfMonth(exports.today),
            endDate: exports.today,
        },
    ],
    [
        exports.SmartDateTypeOptions.currentYearYTD,
        {
            name: exports.SmartDateTypeOptions.currentYearYTD,
            startDate: date_fns_1.startOfYear(exports.today),
            endDate: exports.today,
        },
    ],
    [exports.SmartDateTypeOptions.last2Months, last2Months],
    [exports.SmartDateTypeOptions.last3Months, last3Months],
    [exports.SmartDateTypeOptions.last12Months, last12Months],
    [exports.SmartDateTypeOptions.lastCalendarYear, lastCalendarYear],
    [exports.SmartDateTypeOptions.last2Years, last2Years],
    [exports.SmartDateTypeOptions.last3Years, last3Years],
    [exports.SmartDateTypeOptions.last5Years, last5Years],
    [exports.SmartDateTypeOptions.inceptionToLastMonth, inceptionToLastMonth],
    [
        exports.SmartDateTypeOptions.sinceInception,
        {
            name: exports.SmartDateTypeOptions.sinceInception,
            endDate: exports.today,
        },
    ],
]);
var currentQuarterQTDfirstAndLast = {
    name: exports.SmartDateTypeOptions.currentQuarterQTD,
    startDate: date_fns_1.startOfQuarter(exports.today),
    endDate: date_fns_1.endOfMonth(exports.today),
};
var currentMonthFirstAndLast = {
    name: exports.SmartDateTypeOptions.currentMonthMTD,
    startDate: date_fns_1.startOfMonth(exports.today),
    endDate: date_fns_1.endOfMonth(exports.today),
};
var currentYearFirstAndLast = {
    name: exports.SmartDateTypeOptions.currentYearYTD,
    startDate: date_fns_1.startOfYear(exports.today),
    endDate: date_fns_1.endOfMonth(exports.today),
};
var sinceInceptionToEndOfCurrentMonth = {
    name: exports.SmartDateTypeOptions.sinceInception,
    endDate: date_fns_1.endOfMonth(exports.today),
};
var firstAndLastOfMonthSmartDates = new Map([
    [exports.SmartDateTypeOptions.lastQuarter, lastQuarter],
    [exports.SmartDateTypeOptions.last2Quarters, last2Quarters],
    [exports.SmartDateTypeOptions.last3Quarters, last3Quarters],
    [exports.SmartDateTypeOptions.last4Quarters, last4Quarters],
    [exports.SmartDateTypeOptions.currentQuarterQTD, currentQuarterQTDfirstAndLast],
    [exports.SmartDateTypeOptions.lastMonth, lastMonth],
    [exports.SmartDateTypeOptions.yearToLastMonth, yearToLastMonth],
    [exports.SmartDateTypeOptions.currentMonthMTD, currentMonthFirstAndLast],
    [exports.SmartDateTypeOptions.currentYearYTD, currentYearFirstAndLast],
    [exports.SmartDateTypeOptions.last2Months, last2Months],
    [exports.SmartDateTypeOptions.last3Months, last3Months],
    [exports.SmartDateTypeOptions.last12Months, last12Months],
    [exports.SmartDateTypeOptions.lastCalendarYear, lastCalendarYear],
    [exports.SmartDateTypeOptions.last2Years, last2Years],
    [exports.SmartDateTypeOptions.last3Years, last3Years],
    [exports.SmartDateTypeOptions.last5Years, last5Years],
    [exports.SmartDateTypeOptions.inceptionToLastMonth, inceptionToLastMonth],
    [exports.SmartDateTypeOptions.sinceInception, sinceInceptionToEndOfCurrentMonth],
]);
exports.SmartDates = new Map([
    [exports.DatePickerTypeOptions.dateRange, dateRangeSmartDates],
    [exports.DatePickerTypeOptions.firstAndLastOfMonth, firstAndLastOfMonthSmartDates],
]);
exports.getSmartDate = function (datePickerType, smartDateType) {
    var _a;
    if (!smartDateType) {
        return undefined;
    }
    var smartDateValue = (_a = exports.SmartDates.get(datePickerType)) === null || _a === void 0 ? void 0 : _a.get(smartDateType);
    return smartDateValue || undefined;
};
